export default __webpack_public_path__ + "static/media/mbr-6.43974bad.jpg";